<div class="relative flex flex-col flex-auto min-w-0 overflow-hidden">
<!-- CTA -->
    <div class="px-6 py-10 sm:py-12 sm:px-16 bg-primary-600 text-on-primary-600">
        <div class="flex flex-col items-center w-full max-w-7xl mx-auto text-center">
            <div class="text-3xl sm:text-4xl sm:text-5xl font-extrabold leading-6 sm:leading-10">Hire fast and safe.</div>
            <div class="mt-2 text-3xl sm:text-4xl sm:text-5xl font-extrabold leading-6 sm:leading-10 text-black text-opacity-70">Start using HIRE.ESEEL today.</div>
            <!-- <button
                mat-flat-button
                class="fuse-mat-button-large mt-8 px-12 bg-white text-primary-800">
                <span class="text-lg">Sign up for free</span>
            </button> -->
        </div>
    </div>

    <!-- Frequently asked questions -->
    <div class="flex flex-col items-center pt-12 sm:pt-18 pb-8 sm:pb-20 px-6 sm:px-16 bg-gray-50 dark:bg-gray-800">
        <div class="w-full max-w-7xl">
            <div>
                <div class="text-4xl font-extrabold tracking-tight leading-tight">
                    How It Works ?
                </div>
                <div class="max-w-xl mt-2 text-xl text-secondary">
                    Find, contact then hire.
                </div>
            </div>
            <!-- FAQs grid -->
            <div class="grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2 lg:gap-x-16 w-full mt-12 sm:mt-16">
                <div>
                    <div class="text-xl font-semibold">
                        1. Find a service seller on HIRE.ESEEL
                    </div>
                    <div class="mt-2 leading-6 text-secondary">
                        <p>
                            Navigate and search through the seller profiles on HIRE.ESEEL to find the right skills needed for your project.
                        </p>
                    </div>
                </div>
                <div>
                    <div class="text-xl font-semibold">
                        2. Request a Quotation. 
                    </div>
                    <div class="mt-2 leading-6 text-secondary">
                        <p>
                            Fill up the form and include all your requirements for your project, the seller will contact you shortly with your quotation ready.
                        </p>
                    </div>
                </div>
                <div>
                    <div class="text-xl font-semibold">
                        3. Hire a service seller
                    </div>
                    <div class="mt-2 leading-6 text-secondary">
                        <p>
                            Once you both ( Buyer & Seller ) agree to the project's terms and price quote, ESEEL will email you a payment link. 
                        </p>
                        <p class="mt-2">
                            The payment will be released to the seller upon the buyer's request.
                        </p>
                    </div>
                </div>
                <!-- <div>
                    <div class="text-xl font-semibold">
                        4. Make a payment
                    </div>
                    <div class="mt-2 leading-6 text-secondary">
                        <p>
                            If you are still in your free trial period, you can cancel your
                            account at anytime with a single click of a button. If you already
                            paid for your first month, we also offer 30-day money-back
                            guarantee with no questions asked.
                        </p>
                        <p class="mt-2">
                            After first month, you can still cancel your account at any time
                            but we will calculate the amount that corresponds to days you
                            have been using our app for that month and refund only the
                            remaining amount.
                        </p>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>